import module from 'guest/module.js'
import template from './template.html'

class GuestSoporteAgregarComponent {
  constructor (dialog, $dialogParams, $notify) {
    this.dialog = dialog
    this.$dialogParams = $dialogParams
    this.$notify = $notify
    this.data = $dialogParams['data']
    this.saving = false
    this.options = {
      subject: '',
      message: '',
    }
  }

  agregar () {
    this.saving = true

    this.data.$add({subject: this.options.subject, message: this.options.message})
      .then((data) => (this.dialog.resolve(data)))
      .catch((data) => (this.$notify.error(data)))
      .finally(() => (this.saving = false))
  }

  cancelar () {
    this.dialog.reject()
  }
}

module.controller('GuestSoporteAgregarComponent', GuestSoporteAgregarComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('guest.support.add', {
    controller: 'GuestSoporteAgregarComponent',
    template,
    controllerAs: '$ctrl',
  })
})



// WEBPACK FOOTER //
// ./src/guest/components/soporte/agregar/component.js